import { get, post, del } from './API';

export default {
  fetchDiscountCodes: async () => get('/pricing/discount-codes'),
  fetchDiscountCodeById: async (id) => get('/pricing/discount-codes', { id }),
  createDiscountCode: async (discountCode) => post('/pricing/discount-codes', discountCode),
  updateDiscountCode: async (discountCode) => post('/pricing/discount-codes', discountCode),
  deleteDiscountCode: async (id) => del('/pricing/discount-codes', { id }),
};
